import { z } from "zod";

const SignupSchema = z
    .object({
        firstName: z.string().nonempty("First name is required."),
        lastName: z.string().nonempty("Last name is required."),
        email: z
            .string()
            .nonempty("Email is required.")
            .email("Please provide a valid email address."),
        password: z
            .string()
            .nonempty("Password is required.")
            .min(8, "Password must be at least 8 characters long."),
        confirmPassword: z
            .string()
            .nonempty("Confirm Password is required.")
            .min(8, "Password must be at least 8 characters long."),
        monthlyShipments: z.string().nonempty("Monthly Shipments is required."),
    })
    // Validate that the passwords match
    .refine((data) => data.password === data.confirmPassword, {
        message: "Passwords do not match.",
        path: ["confirmPassword"],
    })
    // Transform firstName and lastName into a single 'name' field
    .transform((data) => ({
        name: `${data.firstName} ${data.lastName}`,
        email: data.email,
        password: data.password,
        monthlyShipments: data.monthlyShipments,
    }));

export default SignupSchema;